import { shopTypeList } from '@/utils/dict.js'
export const searchConfigs = [
  {
    key: ['filterObj', 'target'],
    searchType: 'selectInput',
    componentData: {
      options: [
        { label: window.$t('after-sales::after-sale-list::after_sales_number'), value: 'refundNo' },
        { label: window.$t('after-sales::after-sale-list::order_number'), value: 'orderNo' },
        { label: window.$t('after-sales::after-sale-list::email'), value: 'email' },
        { label: window.$t('after-sales::after-sale-list::spu'), value: 'spuId' },
        { label: window.$t('after-sales::after-sale-list::sku'), value: 'skuId' },
        { label: window.$t('after-sales::after-sale-list::transaction_num'), value: 'paymentNo' }
      ]
    }
  },
  {
    key: 'payType',
    searchType: 'select',
    label: window.$t('after-sales::after-sale-list::label_payment_channel') + ':',
    componentData: {
      options: [
        { label: window.$t('after-sales::after-sale-list::select_unpay'), value: 0 },
        { label: 'PayPal', value: 1 },
        { label: 'Stripe', value: 2 },
        { label: 'WorldPay', value: 3 },
        { label: 'AsiaBill', value: 4 },
        { label: 'OceanPayment', value: 5 },
        { label: 'PacyPay', value: 6 },
        { label: 'PingPongPay', value: 7 },
        { label: 'UseePay', value: 8 },
        { label: 'bogus', value: 9 },
        { label: 'manual', value: 10 }
      ]
    }
  },
  {
    key: 'platform',
    searchType: 'select',
    label: window.$t('after-sales::after-sale-list::label_platform'),
    componentData: {
      options: shopTypeList
    }
  },
  {
    key: 'shopId',
    label: window.$t('after-sales::after-sale-list::label_shop'),
    searchType: 'dict',
    componentData: {
      cache: false,
      dictKey: 'shop_id',
      filterable: true,
      clearable: true
    }
  },
  {
    key: 'time',
    searchType: 'selectDatepicker',
    label: window.$t('after-sales::after-sale-list::application_time'),
    componentData: {
      options: [{ keys: ['create_time_begin', 'create_time_end'] }],
      clearable: true
    }
  },
  {
    key: 'refundReasonId',
    label: window.$t('after-sales::after-sale-list::after_sale_reason'),
    searchType: 'cascader',
    componentData: {
      props: {
        value: 'id',
        label: 'name',
        children: 'childrens',
        leaf: 'level'
      },
      options: [],
      filterable: true,
      clearable: true
    }
  },

  {
    key: 'dutyId',
    label: window.$t('after-sales::after-sale-list::responsible_party'),
    searchType: 'dict',
    componentData: {
      cache: false,
      dictKey: 'duty_id',
      filterable: true,
      clearable: true
    }
  },
  {
    key: 'sourceId',
    label: window.$t('after-sales::after-sale-list::after_sale_source'),
    searchType: 'dict',
    componentData: {
      cache: false,
      dictKey: 'source_id',
      filterable: true,
      clearable: true
    }
  },
  {
    key: 'refundTypeId',
    label: window.$t('after-sales::after-sale-list::refund_type'),
    searchType: 'dict',
    componentData: {
      cache: false,
      dictKey: 'refund_id',
      filterable: true,
      clearable: true
    }
  },
  {
    key: 'applyBy',
    label: window.$t('after-sales::after-sale-list::applicant'),
    searchType: 'dict',
    componentData: {
      cache: false,
      dictKey: 'auth_user',
      filterable: true,
      clearable: true
    }
  }
]

export const pendingColumn = [
  {
    type: 'selection',
    fixed: true
  },
  {
    prop: 'refundNo',
    label: window.$t('after-sales::after-sale-list::table_after_sale_order_num'),
    width: '250px',
    fixed: 'left'
  },
  {
    prop: 'good',
    label: window.$t('after-sales::after-sale-list::table_commodity'),
    width: '100px'
  },
  {
    prop: 'price',
    label: window.$t('after-sales::after-sale-list::table_sales_price'),
    width: '150'
  },
  {
    prop: 'refundReasonMsg',
    label: window.$t('after-sales::after-sale-list::table_sales_reason'),
    minWidth: '200px'
  },
  {
    prop: 'email',
    label: window.$t('after-sales::after-sale-list::table_email'),
    width: '220px'
  },
  {
    prop: 'orderNo',
    label: window.$t('after-sales::after-sale-list::table_order_num'),
    width: '220px'
  },
  {
    prop: 'payType',
    label: window.$t('after-sales::after-sale-list::table_pay_channel'),
    minWidth: '150'
  },
  {
    prop: 'afterSaleType',
    label: window.$t('after-sales::after-sale-list::table_type'),
    width: '200px'
  },
  {
    prop: 'shopName',
    label: window.$t('after-sales::after-sale-list::table_shop'),
    width: '150px'
  },
  {
    prop: 'createTime',
    label: window.$t('after-sales::after-sale-list::table_application_time'),
    width: '200px'
  },
  {
    prop: 'remark',
    label: window.$t('after-sales::after-sale-list::table_remark'),
    width: '100px'
  },
  {
    prop: 'status',
    label: window.$t('after-sales::after-sale-list::table_status'),
    width: '100px',
    fixed: 'right'
  },
  {
    prop: 'operation',
    label: window.$t('after-sales::after-sale-list::table_opt'),
    width: '250',
    fixed: 'right'
  }
]

export const refundStatus = {
  0: window.$t('after-sales::after-sale-list::select_wait'),
  1: window.$t('after-sales::after-sale-list::select_reject'),
  2: window.$t('after-sales::after-sale-list::select_wait_refund'),
  3: window.$t('after-sales::after-sale-list::select_closed'),
  4: window.$t('after-sales::after-sale-list::select_has_redunded')
}
